import { initSortableUpdateSortField } from "./sort";

function initLinkForm() {
  const formSelector = ".js-link-form";
  const formNewSelector = ".js-link-form-new";
  const btnDeleteSelector = ".js-link-form-delete";

  const wrap = document.querySelector(".js-link-forms");
  const btnAdd = document.querySelector(".js-link-form-add");

  if (!wrap || !btnAdd) return;

  const url = wrap.getAttribute("data-url");

  btnAdd.addEventListener("click", async () => {
    const id = document.querySelectorAll(formNewSelector).length;
    const fullurl = `${url}?id=${id}`;

    try {
      const response = await fetch(fullurl);

      const result = await response.json();

      wrap.insertAdjacentHTML("beforeend", result.html);

      initSortableUpdateSortField(wrap);
    } catch (e) {
      console.error(e);
    }
  });

  wrap.addEventListener("click", (e) => {
    const btn = e.target.closest(btnDeleteSelector);
    if (!btn) return;

    const form = btn.closest(formSelector);
    if (!form) return;

    form.remove();

    initSortable(wrap);
  });
}

function initUserLinkForm() {
  const wrapSelector = ".js-user-link-forms";
  const formSelector = ".js-user-link-form";
  const formNewSelector = ".js-user-link-form-new";
  const btnDeleteSelector = ".js-user-link-form-delete";
  const btnAddSelector = ".js-user-link-form-add";

  const wrapper = document.querySelector(wrapSelector);
  const btnAdd = document.querySelector(btnAddSelector);

  if (!wrapper || !btnAdd) return;

  const url = wrapper.getAttribute("data-url");

  btnAdd.addEventListener("click", async (e) => {
    const id = wrapper.querySelectorAll(formNewSelector).length;

    const response = await fetch(`${url}?id=${id}`, {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    const data = await response.json();

    wrapper.insertAdjacentHTML("beforeend", data.html);

    initSortable(wrapper);
  });

  wrapper.addEventListener("click", (e) => {
    const btn = e.target.closest(btnDeleteSelector);
    if (!btn) return;

    const form = btn.closest(formSelector);
    if (!form) return;

    form.remove();

    initSortable(wrapper);
  });
}

function initContestFormFeeType() {
  const radioList = document.querySelectorAll(".js-fee_type-radio");
  const fieldsetList = document.querySelectorAll(".js-fee_type-fieldset");

  if (!radioList.length || !fieldsetList.length) return;

  const hiddenClass = "hidden";

  for (let i = 0; i < radioList.length; i++) {
    const radio = radioList[i];

    let curFieldset = null;

    if (radio.hasAttribute("data-fieldset")) {
      curFieldset = document.querySelector(radio.getAttribute("data-fieldset"));
    }

    for (let k = 0; k < fieldsetList.length; k++) {
      const fieldset = fieldsetList[k];

      if (radio.checked && fieldset === curFieldset) {
        fieldset.classList.remove(hiddenClass);
        fieldset.disabled = false;
      } else {
        fieldset.classList.add(hiddenClass);
        fieldset.disabled = true;
      }
    }

    radio.addEventListener("change", (e) => {
      for (let k = 0; k < fieldsetList.length; k++) {
        const fieldset = fieldsetList[k];

        if (radio.checked && fieldset === curFieldset) {
          fieldset.classList.remove(hiddenClass);
          fieldset.disabled = false;
        } else {
          fieldset.classList.add(hiddenClass);
          fieldset.disabled = true;
        }
      }
    });
  }
}

function initContestFormNominationType() {
  const radioList = document.querySelectorAll(".js-nomination_type-radio");
  const fieldsetList = document.querySelectorAll(
    ".js-nomination_type-fieldset"
  );

  if (!radioList.length || !fieldsetList.length) return;

  const hiddenClass = "hidden";

  for (let i = 0; i < radioList.length; i++) {
    const radio = radioList[i];

    let curFieldset = null;

    if (radio.hasAttribute("data-fieldset")) {
      curFieldset = document.querySelector(radio.getAttribute("data-fieldset"));
    }

    for (let k = 0; k < fieldsetList.length; k++) {
      const fieldset = fieldsetList[k];

      if (radio.checked && fieldset === curFieldset) {
        fieldset.classList.remove(hiddenClass);
        fieldset.disabled = false;
      } else {
        fieldset.classList.add(hiddenClass);
        fieldset.disabled = true;
      }
    }

    radio.addEventListener("change", (e) => {
      for (let k = 0; k < fieldsetList.length; k++) {
        const fieldset = fieldsetList[k];

        if (radio.checked && fieldset === curFieldset) {
          fieldset.classList.remove(hiddenClass);
          fieldset.disabled = false;
        } else {
          fieldset.classList.add(hiddenClass);
          fieldset.disabled = true;
        }
      }
    });
  }
}

function initWorkFormUserType() {
  const radioList = document.querySelectorAll(".js-user_type-radio");
  const fieldsetList = document.querySelectorAll(".js-user_type-fieldset");

  if (!radioList.length || !fieldsetList.length) return;

  const hiddenClass = "hidden";

  for (let i = 0; i < radioList.length; i++) {
    const radio = radioList[i];

    let curFieldset = null;

    if (radio.hasAttribute("data-fieldset")) {
      curFieldset = document.querySelector(radio.getAttribute("data-fieldset"));
    }

    for (let k = 0; k < fieldsetList.length; k++) {
      const fieldset = fieldsetList[k];

      if (radio.checked && fieldset === curFieldset) {
        fieldset.classList.remove(hiddenClass);
        fieldset.disabled = false;
      } else {
        fieldset.classList.add(hiddenClass);
        fieldset.disabled = true;
      }
    }

    radio.addEventListener("change", (e) => {
      for (let k = 0; k < fieldsetList.length; k++) {
        const fieldset = fieldsetList[k];

        if (radio.checked && fieldset === curFieldset) {
          fieldset.classList.remove(hiddenClass);
          fieldset.disabled = false;
        } else {
          fieldset.classList.add(hiddenClass);
          fieldset.disabled = true;
        }
      }
    });
  }
}

function initWorkFormRepresentative() {
  const radioList = document.querySelectorAll(".js-representative-radio");
  const fieldsetList = document.querySelectorAll(".js-representative-fieldset");

  if (!radioList.length || !fieldsetList.length) return;

  const hiddenClass = "hidden";

  for (let i = 0; i < radioList.length; i++) {
    const radio = radioList[i];

    let curFieldset = null;

    if (radio.hasAttribute("data-fieldset")) {
      curFieldset = document.querySelector(radio.getAttribute("data-fieldset"));
    }

    for (let k = 0; k < fieldsetList.length; k++) {
      const fieldset = fieldsetList[k];

      if (radio.checked && fieldset === curFieldset) {
        fieldset.classList.remove(hiddenClass);
        fieldset.disabled = false;
      } else {
        fieldset.classList.add(hiddenClass);
        fieldset.disabled = true;
      }
    }

    radio.addEventListener("change", (e) => {
      for (let k = 0; k < fieldsetList.length; k++) {
        const fieldset = fieldsetList[k];

        if (radio.checked && fieldset === curFieldset) {
          fieldset.classList.remove(hiddenClass);
          fieldset.disabled = false;
        } else {
          fieldset.classList.add(hiddenClass);
          fieldset.disabled = true;
        }
      }
    });
  }
}

function initContestFormUseAge() {
  const checkbox = document.querySelector(".js-use-age-checkbox");
  const fieldset = document.querySelector(".js-use-age-fieldset");

  if (!checkbox || !fieldset) return;

  const hiddenClass = "hidden";

  if (!checkbox.checked) {
    fieldset.classList.add(hiddenClass);
    fieldset.disabled = true;
  }

  checkbox.addEventListener("change", (e) => {
    if (checkbox.checked) {
      fieldset.classList.remove(hiddenClass);
      fieldset.disabled = false;
    } else {
      fieldset.classList.add(hiddenClass);
      fieldset.disabled = true;
    }
  });
}

function initContestFormAddCategory() {
  const checkbox = document.querySelector(".js-add-category-checkbox");
  const fieldset = document.querySelector(".js-category-new-fieldset");

  if (!checkbox || !fieldset) return;

  const hiddenClass = "hidden";

  if (!checkbox.checked) {
    fieldset.classList.add(hiddenClass);
  }

  checkbox.addEventListener("change", (e) => {
    fieldset.classList.toggle(hiddenClass, !checkbox.checked);
  });
}

function initContestFormAddNomination() {
  const checkbox = document.querySelector(".js-add-nomination-checkbox");
  const fieldset = document.querySelector(".js-nomination-new-fieldset");

  if (!checkbox || !fieldset) return;

  const hiddenClass = "hidden";

  if (!checkbox.checked) {
    fieldset.classList.add(hiddenClass);
  }

  checkbox.addEventListener("change", (e) => {
    fieldset.classList.toggle(hiddenClass, !checkbox.checked);
  });
}

function initJudgingFormCompareChange() {
  const formSelector = ".js-judging-compare-change-form";
  const numberSelector = ".js-judging-compare-change-number";
  const compareSelector = ".js-judging-compare";
  const barSelector = ".js-judging-compare-bar";

  const barAddedClass = "judging-compare-bar_added";
  const compareAddedClass = "judging-compare_added";

  const form = document.querySelector(formSelector);
  const number = document.querySelector(numberSelector);
  const bar = document.querySelector(barSelector);

  if (!form || !bar) return;

  let btnText = "";

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const btn = e.submitter;

    if (!btn) return;

    const response = await fetch(
      `${form.getAttribute("action")}?${btn.name}=${btn.value}`,
      {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
        method: form.getAttribute("method"),
        body: new FormData(form),
      }
    );

    const data = await response.json();

    if ("ok" !== data.status) {
      alert(data.message);
      return;
    }

    if (number) {
      number.textContent = data.count;
    }

    if ("added" === data.action) {
      btnText = btn.getAttribute("data-delete-text");

      btn.closest(compareSelector).classList.add(compareAddedClass);

      bar.classList.add(barAddedClass);
    }

    if ("deleted" === data.action) {
      btnText = btn.getAttribute("data-add-text");

      btn.closest(compareSelector).classList.remove(compareAddedClass);
    }

    if (0 === +data.count) {
      bar.classList.remove(barAddedClass);
    }

    btn.innerHTML = btnText;
  });
}

function initJudgingValueForm() {
  const wrapperSelector = ".js-judging-value-form-wrapper";
  const formSelector = ".js-judging-value-form";
  const moderFormBtnSelector = ".js-judging-value-modern-form-btn";
  const modernFormBtnDefaultClass = "btn_outline";

  const wrapper = document.querySelector(wrapperSelector);
  if (!wrapper) return;

  wrapper.addEventListener("change", async (e) => {
    const form = e.target.closest(formSelector);
    if (!form) return;

    e.preventDefault();

    const response = await fetch(`${form.getAttribute("action")}`, {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
      method: form.getAttribute("method"),
      body: new FormData(form),
    });

    const data = await response.json();

    if ("ok" !== data.status) {
      alert(data.message);
    }
  });

  wrapper.addEventListener("click", async (e) => {
    const curBtn = e.target.closest(moderFormBtnSelector);
    if (!curBtn) return;

    e.preventDefault();

    const form = curBtn.closest("form");
    if (!form) return;

    const btnList = form.querySelectorAll('button[type="submit"]');

    const formData = new FormData(form);
    formData.set(curBtn.name, curBtn.value);

    const response = await fetch(`${form.getAttribute("action")}`, {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
      method: form.getAttribute("method"),
      body: formData,
    });

    const data = await response.json();

    if ("ok" !== data.status) {
      alert(data.message);
      return;
    }

    if (data.hasOwnProperty("value")) {
      btnList.forEach((btn) => {
        if (+btn.value === +data.value) {
          btn.classList.remove(modernFormBtnDefaultClass);
        } else {
          btn.classList.add(modernFormBtnDefaultClass);
        }
      });
    }
  });
}

export {
  initContestFormFeeType,
  initContestFormNominationType,
  initWorkFormUserType,
  initWorkFormRepresentative,
  initContestFormUseAge,
  initContestFormAddCategory,
  initContestFormAddNomination,
  initJudgingFormCompareChange,
  initJudgingValueForm,
  initUserLinkForm,
  initLinkForm,
};
